export const CATEGORY_TABS_LIST = [
  {
    value: "AIR SYSTEM",
    label: "AIR SYSTEM",
  },
  {
    value: "Fuel System",
    label: "Fuel System",
  },
  {
    value: "Lube System",
    label: "Lube System",
  },
  {
    value: "Coolant Condition",
    label: "Coolant Condition",
  },
  {
    value: "Over heat",
    label: "Over heat",
  },
  {
    value: "Electrical System",
    label: "Electrical System",
  },
  {
    value: "Engine side",
    label: "Engine side",
  },
  {
    value: "Open condition",
    label: "Open condition",
  },
  {
    value: "External & Vehicle side",
    label: "External & Vehicle side",
  },
  {
    value: "LOC Trial",
    label: "LOC Trial",
  },
  {
    value: "Others",
    label: "Others",
  },
];
export const FUEL_SYSTEM_QUESTIONS = [
  {
    label: "Fuel level in tank",
    options: [
      { label: "Observed Fully filled", apiOptionKey: "observedFullyFilled" },
      {
        label: "Observed Half tank filled",
        apiOptionKey: "observedHalfTankFilled",
      },
      {
        label: "Observed No fuel in tank",
        apiOptionKey: "observedNoFuelInTank",
      },
    ],
  },
  {
    label: "Fuel Tank Stainer Condition",
    options: [
      {
        label: "Found Clean and no blockage observed",
        apiOptionKey: "foundCleanAndNoBlockageObserved",
      },
      { label: "Found Blockage", apiOptionKey: "foundBlockage" },
    ],
  },
  {
    label: "Breather System in Fuel Tank",
    options: [
      { label: "Found ok", apiOptionKey: "q3o1" },
      { label: "Found blockage", apiOptionKey: "foundBlockageBreather" },
      {
        label: "No Breather system in Fuel tank",
        apiOptionKey: "noBreatherSystemInfuelTank",
      },
    ],
  },
  {
    label: "Fuel Stop lever condition observed",
    options: [
      { label: "At Rest position", apiOptionKey: "atRestPosition" },
      {
        label: "At partial pull condition",
        apiOptionKey: "atPartialPullCondition",
      },
      {
        label: "At fully pulled condition	",
        apiOptionKey: "atFullyPulledCondition",
      },
    ],
  },
  {
    label: "Fuel supply Condition",
    options: [
      {
        label: "Found Air in fuel system",
        apiOptionKey: "foundAirInFuelSystem",
      },
      {
        label: "Found low pressure pipe blocked",
        apiOptionKey: "foundLowPressurePipeBlocked",
      },
      {
        label: "Found low pressure pipe bend",
        apiOptionKey: "foundLowpressurePipeBend",
      },
      {
        label: "Found Fuel hose banjo washer damage",
        apiOptionKey: "foundFuelHoseBanjoWasherDamage",
      },
      {
        label: "Found overflow valve faulty",
        apiOptionKey: "foundOverflowValveFaulty",
      },
      {
        label: "Found fuel leakage in Low pressure pipes",
        apiOptionKey: "foundFuelLeakageInLowPressurePipes",
      },
    ],
  },
  {
    label:
      "Fuel Low pressure hoses inlet diameter(mm (Note : Minimum 8 mm required))",
    type: "INPUT",
    apiKey: "fuelLowPressureHosesInletDiameter",
    // options: [],
  },
  {
    label: "Fuel Filter condition",
    options: [
      { label: "Found ok", apiOptionKey: "q6o1" },
      { label: "Found clogged", apiOptionKey: "foundClogged" },
      { label: "Found damaged", apiOptionKey: "foundDamaged" },
      { label: "Found Water in filter", apiOptionKey: "foundWaterInFilter" },
      {
        label: "Found fuel Inlet and outlet hoses are interchanged.",
        apiOptionKey: "foundFuelInletAndOutletHosesAreInterchanged",
      },
    ],
  },
  {
    label: "Fuel Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q7o1" },
      { label: "Found fuel adulterated	", apiOptionKey: "foundFuelAdulterated" },
    ],
  },
  {
    label: "Fuel Pump injection Timing",
    options: [
      {
        label: "Found Advance in degree / mm",
        apiOptionKey: "foundAdvanceInDegreePerMM",
        type: "INPUT",
      },
      {
        label: "Found retard in degree / mm",
        apiOptionKey: "foundRetardInDegreePerMM",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Fuel Pump Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      { label: "Found pump faulty", apiOptionKey: "foundPumpFaulty" },
    ],
  },
  {
    label: "Fuel Injector Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q10o1" },
      {
        label: "Found 1st Injector faulty",
        apiOptionKey: "foundFirstInjectorFaulty",
      },
      {
        label: "Found 2nd Injector faulty",
        apiOptionKey: "foundSecondInjectorFaulty",
      },
      {
        label: "Found 3rd Injector faulty",
        apiOptionKey: "foundThirdInjectorFaulty",
      },
      {
        label: "Found 4th Injector faulty",
        apiOptionKey: "foundFourthInjectorFaulty",
      },
    ],
  },
  {
    label: "Common Rail condition",
    options: [
      { label: "Found ok", apiOptionKey: "q11o1" },
      {
        label: "Found fuel leak from Pressure relief valve	",
        apiOptionKey: "foundFuelLeakFromPressureReliefValve",
      },
    ],
  },
];
export const mappingFuelSystemDetailsToUI = (details) => {
  const {
    fuelLevelInTank,
    fuelTankStainerCondition,
    breatherSystemInFuelTank,
    fuelStopLeverConditionObserved,
    fuelSupplyCondition,
    fuelLowPressureHosesInletDiameter,
    fuelFilterCondition,
    fuelCondition,
    fuelPumpInjectionTiming,
    fuelPumpCondition,
    fuelInjectorCondition,
    commonRailCondition,
  } = details;
  let responseDetails = {
    observedFullyFilled: fuelLevelInTank?.observedFullyFilled,
    observedHalfTankFilled: fuelLevelInTank?.observedHalfTankFilled,
    observedNoFuelInTank: fuelLevelInTank?.observedNoFuelInTank,

    foundCleanAndNoBlockageObserved:
      fuelTankStainerCondition?.foundCleanAndNoBlockageObserved,
    foundBlockage: fuelTankStainerCondition?.foundBlockage,
    fuelLowPressureHosesInletDiameter: fuelLowPressureHosesInletDiameter,
    q3o1: breatherSystemInFuelTank?.foundOk,
    foundBlockageBreather: breatherSystemInFuelTank?.foundBlockage,
    noBreatherSystemInfuelTank:
      breatherSystemInFuelTank?.noBreatherSystemInfuelTank,

    atRestPosition: fuelStopLeverConditionObserved?.atRestPosition,
    atPartialPullCondition:
      fuelStopLeverConditionObserved?.atPartialPullCondition,
    atFullyPulledCondition:
      fuelStopLeverConditionObserved?.atFullyPulledCondition,

    foundAirInFuelSystem: fuelSupplyCondition?.foundAirInFuelSystem,
    foundLowPressurePipeBlocked:
      fuelSupplyCondition?.foundLowPressurePipeBlocked,
    foundLowpressurePipeBend: fuelSupplyCondition?.foundLowpressurePipeBend,
    foundFuelHoseBanjoWasherDamage:
      fuelSupplyCondition?.foundFuelHoseBanjoWasherDamage,
    foundOverflowValveFaulty: fuelSupplyCondition?.foundOverflowValveFaulty,
    foundFuelLeakageInLowPressurePipes:
      fuelSupplyCondition?.foundFuelLeakageInLowPressurePipes,

    q6o1: fuelFilterCondition?.foundOk,
    foundClogged: fuelFilterCondition?.foundClogged,
    foundDamaged: fuelFilterCondition?.foundDamaged,
    foundWaterInFilter: fuelFilterCondition?.foundWaterInFilter,
    foundFuelInletAndOutletHosesAreInterchanged:
      fuelFilterCondition?.foundFuelInletAndOutletHosesAreInterchanged,

    q7o1: fuelCondition?.foundOk,
    foundFuelAdulterated: fuelCondition?.foundFuelAdulterated,

    foundAdvanceInDegreePerMM:
      fuelPumpInjectionTiming?.foundAdvanceInDegreePerMM,
    foundRetardInDegreePerMM: fuelPumpInjectionTiming?.foundRetardInDegreePerMM,

    q9o1: fuelPumpCondition?.foundOk,
    foundPumpFaulty: fuelPumpCondition?.foundPumpFaulty,

    q10o1: fuelInjectorCondition?.foundOk,
    foundFirstInjectorFaulty: fuelInjectorCondition?.foundFirstInjectorFaulty,
    foundSecondInjectorFaulty: fuelInjectorCondition?.foundSecondInjectorFaulty,
    foundThirdInjectorFaulty: fuelInjectorCondition?.foundThirdInjectorFaulty,
    foundFourthInjectorFaulty: fuelInjectorCondition?.foundFourthInjectorFaulty,

    q11o1: commonRailCondition?.foundOk,
    foundFuelLeakFromPressureReliefValve:
      commonRailCondition?.foundFuelLeakFromPressureReliefValve,
  };
  return responseDetails;
};
export const LUBE_SYSTEM_QUESTIONS = [
  {
    label: "Oil filter Make",
    options: [
      {
        label: "Simpson Recommended Filter used",
        apiOptionKey: "simpsonRecommendedFilterUsed",
      },
      {
        label: "Non- Recommended Filter Used",
        apiOptionKey: "nonRecommendedFilterUsed",
      },
    ],
  },

  {
    label: "Oil Details",
    options: [
      {
        label: "Oil Grade",
        type: "INPUT",
        apiOptionKey: "oilMake",
      },
      {
        label: "Oil Make",
        type: "INPUT",
        apiOptionKey: "oilMake",
      },
    ],
  },

  {
    label: "Oil condition",
    options: [
      {
        label: "Found ok",
        apiOptionKey: "q2o1",
      },
      {
        label: "Found Diesel Mix",
        apiOptionKey: "foundDieselMix",
      },
      {
        label: "Found Greasy",
        apiOptionKey: "foundGreasy",
      },
      {
        label: "Found Blackish",
        apiOptionKey: "foundBlackish",
      },
      {
        label: "Found Coolant Mix",
        apiOptionKey: "foundCoolantMix",
      },
    ],
  },
  {
    label:
      "Oil Level in Sump (Mark the line with corresponding ‘X’ in dipstick)",
    apiKey: "oilLevelInSump",
    type: "INPUT",
    options: [],
  },
  {
    label: "Oil Pressure Observed (Bar / Kg/Cm2)",
    apiKey: "oilPressureObservedInBarPerKgPerCmSquare",
    type: "INPUT",
    options: [],
  },
  {
    label: "Oil Filter Condition	",
    options: [
      { label: "Found ok", apiOptionKey: "q5o1" },
      { label: "Found Clogged", apiOptionKey: "foundClogged" },
      { label: "Found Oil leakage", apiOptionKey: "foundOilLeakage" },
      { label: "Found damaged", apiOptionKey: "foundDamaged" },
    ],
  },
  {
    label: "Oil Cooler Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q6o1" },
      { label: "Found Clogged", apiOptionKey: "q6o2" },
      { label: "Found Oil leakage", apiOptionKey: "q6o3" },
      { label: "Found damaged", apiOptionKey: "q6o4" },
    ],
  },
];
export const mappingLubeSystemDetailsToUI = (details) => {
  const {
    oilFilterMake,
    oilGrade,
    oilCondition,
    oilMake,
    oilLevelInSump,
    oilPressureObservedInBarPerKgPerCmSquare,
    oilFilterCondition,
    oilCoolerCondition,
  } = details;

  let responseDetails = {
    simpsonRecommendedFilterUsed: oilFilterMake?.simpsonRecommendedFilterUsed,
    nonRecommendedFilterUsed: oilFilterMake?.nonRecommendedFilterUsed,

    oilGrade: oilGrade,
    oilMake: oilMake,

    q2o1: oilCondition?.foundOk,
    foundDieselMix: oilCondition?.foundDieselMix,
    foundGreasy: oilCondition?.foundGreasy,
    foundBlackish: oilCondition?.foundBlackish,
    foundCoolantMix: oilCondition?.foundCoolantMix,

    oilLevelInSump: `${oilLevelInSump || ""}`,

    oilPressureObservedInBarPerKgPerCmSquare: `${
      oilPressureObservedInBarPerKgPerCmSquare || ""
    }`,

    q5o1: oilFilterCondition?.foundOk,
    foundClogged: oilFilterCondition?.foundClogged,
    foundOilLeakage: oilFilterCondition?.foundOilLeakage,
    foundDamaged: oilFilterCondition?.foundDamaged,

    q6o1: oilCoolerCondition?.foundOk,
    q6o2: oilCoolerCondition?.foundClogged,
    q6o3: oilCoolerCondition?.foundOilLeakage,
    q6o4: oilCoolerCondition?.foundDamaged,
  };
  return responseDetails;
};
export const OVER_HEAT_QUESTIONS = [
  {
    label: "Application used",
    apiKey: "applicationUsed",
    type: "INPUT",
    options: [],
  },

  {
    label:
      "How long customer used the vehicle in this application before this complaint was observed",
    apiKey: "customerUseTimeBeforeComplaint",
    type: "INPUT",
    options: [],
  },

  {
    label:
      "In case of overheating, Is the complaint observed on any specific application",
    apiKey: "isOverHeatingOnAnySpecificApplication",
    type: "INPUT",
    options: [],
  },
  {
    label: "Is it self-driven by Customer or by some operator",
    apiKey: "selfDrivenOrOperatorDriven",
    type: "INPUT",
    options: [],
  },
  {
    label:
      "In case of over heating, What did the customer observed first (Overheating or Coolant throw)",
    apiKey: "inCaseOfOverheatingFirstObservation",
    type: "RADIO",
    options: [
      {
        label: "OVER HEATING",
        apiOptionKey: "OVER_HEATING",
        value: "OVER_HEATING",
      },
      {
        label: "COOLANT THROW",
        apiOptionKey: "COOLANT_THROW",
        value: "COOLANT_THROW",
      },
    ],
  },
  {
    label:
      "Any Overheating indication observed by customer/operator on the cluster",
    apiKey: "anyOverheatingObservedOntheCluster",
    type: "RADIO",
    options: [
      { label: "YES", apiOptionKey: "YES", value: "YES" },
      { label: "NO", apiOptionKey: "NO", value: "NO" },
    ],
  },
];
export const mappingOverHeatDetailsToUI = (details) => {
  let responseDetails = {
    applicationUsed: details.applicationUsed,
    customerUseTimeBeforeComplaint: details.customerUseTimeBeforeComplaint,
    isOverHeatingOnAnySpecificApplication:
      details.isOverHeatingOnAnySpecificApplication,
    selfDrivenOrOperatorDriven: details.selfDrivenOrOperatorDriven,
    inCaseOfOverheatingFirstObservation:
      details.inCaseOfOverheatingFirstObservation,
    anyOverheatingObservedOntheCluster:
      details.anyOverheatingObservedOntheCluster,
  };
  return responseDetails;
};
export const ELECTRICAL_SYSTEM_QUESTIONS = [
  {
    label: "Battery Static Voltage (VDC) observed",
    type: "INPUT",
    apiKey: "batteryStaticVoltageObserved",
    options: [],
  },
  {
    label: "Battery Voltage during Cranking observed",
    type: "INPUT",
    apiKey: "batteryVoltageDuringCrankingObserved",
    options: [],
  },
  {
    label: "Battery Cable",
    options: [
      {
        label: "Found Intact",
        apiOptionKey: "foundIntact",
      },
      {
        label: "Found Loose fitted",
        apiOptionKey: "foundLooseFitted",
      },
      {
        label: "Found +ve and -ve cables inter connected",
        apiOptionKey: "foundPositiveAndNegativeCableInterconnected",
      },
    ],
  },
  {
    label: "Fuse Condition",
    options: [
      {
        label: "Found ok",
        apiOptionKey: "q4o1",
      },
      {
        label: "Found blown off",
        apiOptionKey: "foundBlownOff",
      },
    ],
  },
  {
    label: "Blown off fuse",
    options: [
      {
        label: "5 AMPS",
        apiOptionKey: "5amps",
      },
      {
        label: "10 AMPS",
        apiOptionKey: "10amps",
      },
      {
        label: "15 AMPS",
        apiOptionKey: "15amps",
      },
      {
        label: "20 AMPS",
        apiOptionKey: "20amps",
      },
      {
        label: "30 AMPS",
        apiOptionKey: "30amps",
      },
      {
        label: "60 AMPS",
        apiOptionKey: "60amps",
      },
    ],
  },
  {
    label: "ECU Relay Condition",
    options: [
      {
        label: "Found ok",
        apiOptionKey: "q5o1",
      },
      {
        label: "Found loose",
        apiOptionKey: "foundLoose",
      },
      {
        label: "Found backout pins",
        apiOptionKey: "foundBackoutPins",
      },
    ],
  },
  {
    label: "ECU connection to Diagnostic Tool",
    options: [
      {
        label: "Connected and all Parameters displayed",
        apiOptionKey: "connectedAndAllParametersDisplayed",
      },
      {
        label: "Connected but No Parameters displayed",
        apiOptionKey: "connectedButNoParametersDisplayed",
      },
      {
        label: "Not connected",
        apiOptionKey: "notConnected",
      },
    ],
  },
  {
    label: "Engine Wiring Harness",
    options: [
      { label: "Connected", apiOptionKey: "connected" },
      { label: "Found burnt", apiOptionKey: "foundBurnt" },
      { label: "Found Pins back out", apiOptionKey: "foundPinsBackOut" },
      { label: "Found Harness damaged", apiOptionKey: "foundHarnessDamaged" },
      {
        label: "Found tampered for external electrical accessories",
        apiOptionKey: "foundTamperedForExternalElectricalAccessories",
      },
    ],
  },
  {
    label: "Battery Charging Alternator",
    options: [
      { label: "Found ok", apiOptionKey: "q8o1" },
      { label: "Found faulty", apiOptionKey: "q8o2" },
    ],
  },
  {
    label: "ECU Grounding",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      { label: "No grounding provided", apiOptionKey: "noGroundingProvided" },
    ],
  },
  {
    label: "Crank Sensor Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q10o1" },
      {
        label: "Found rubbing mark at tip",
        apiOptionKey: "foundRubbingMarkAtTip",
      },
      { label: "Found faulty", apiOptionKey: "q10o3" },
    ],
  },
  {
    label: "Fuel Metering Unit - MPROP",
    options: [
      { label: "Found ok", apiOptionKey: "q11o1" },
      {
        label: "Wiring harness connector got disconnected",
        apiOptionKey: "wiringHarnessConnectorGotDisconnected",
      },
      { label: "Found faulty", apiOptionKey: "q11o3" },
      {
        label: "No Supply Voltage in harness connector (Pin 2)",
        apiOptionKey: "noSupplyVoltageInHarnessConnectorPin2",
      },
    ],
  },
  {
    label: "Acclerator Pedal",
    options: [
      { label: "Found ok", apiOptionKey: "q12o1" },
      {
        label: "Wiring harness connector got disconnected",
        apiOptionKey: "q12o2",
      },
      { label: "Found faulty", apiOptionKey: "q12o3" },
      {
        label: "No Supply Voltage in harness connector",
        apiOptionKey: "noSupplyVoltageInHarnessConnector",
      },
    ],
  },
];

export const mappingElectricalSystemDetailsToUI = (details) => {
  const {
    batteryStaticVoltageObserved,
    batteryVoltageDuringCrankingObserved,
    batteryCable,
    fuseCondition,
    blownOffFuse,
    ecuRelayCondition,
    ecuConnectionToDiagnosticTool,
    engineWiringHarness,
    batteryChargingAlternator,
    ecuGrounding,
    crankSensorCondition,
    fuelMeteringUnitMPROP,
    acceleratorPedal,
  } = details;

  let responseDetails = {
    batteryStaticVoltageObserved,
    batteryVoltageDuringCrankingObserved,

    foundIntact: batteryCable?.foundIntact,
    foundLooseFitted: batteryCable?.foundLooseFitted,
    foundPositiveAndNegativeCableInterconnected:
      batteryCable?.foundPositiveAndNegativeCableInterconnected,

    q4o1: fuseCondition?.foundOk,
    foundBlownOff: fuseCondition?.foundBlownOff,

    "5amps": blownOffFuse?.["5amps"],
    "10amps": blownOffFuse?.["10amps"],
    "15amps": blownOffFuse?.["15amps"],
    "20amps": blownOffFuse?.["20amps"],
    "30amps": blownOffFuse?.["30amps"],
    "60amps": blownOffFuse?.["60amps"],

    q5o1: ecuRelayCondition?.foundOk,
    foundLoose: ecuRelayCondition?.foundLoose,
    foundBackoutPins: ecuRelayCondition?.foundBackoutPins,

    connectedAndAllParametersDisplayed:
      ecuConnectionToDiagnosticTool?.connectedAndAllParametersDisplayed,
    connectedButNoParametersDisplayed:
      ecuConnectionToDiagnosticTool?.connectedButNoParametersDisplayed,
    notConnected: ecuConnectionToDiagnosticTool?.notConnected,

    connected: engineWiringHarness?.connected,
    foundBurnt: engineWiringHarness?.foundBurnt,
    foundPinsBackOut: engineWiringHarness?.foundPinsBackOut,
    foundHarnessDamaged: engineWiringHarness?.foundHarnessDamaged,
    foundTamperedForExternalElectricalAccessories:
      engineWiringHarness?.foundTamperedForExternalElectricalAccessories,

    q8o1: batteryChargingAlternator?.foundOk,
    q8o2: batteryChargingAlternator?.foundFaulty,

    q9o1: ecuGrounding?.foundOk,
    noGroundingProvided: ecuGrounding?.noGroundingProvided,

    q10o1: crankSensorCondition?.foundOk,
    foundRubbingMarkAtTip: crankSensorCondition?.foundRubbingMarkAtTip,
    q10o3: crankSensorCondition?.foundFaulty,

    q11o1: fuelMeteringUnitMPROP?.foundOk,
    wiringHarnessConnectorGotDisconnected:
      fuelMeteringUnitMPROP?.wiringHarnessConnectorGotDisconnected,
    q11o3: fuelMeteringUnitMPROP?.foundFaulty,
    noSupplyVoltageInHarnessConnectorPin2:
      fuelMeteringUnitMPROP?.noSupplyVoltageInHarnessConnectorPin2,

    q12o1: acceleratorPedal?.foundOk,
    q12o2: acceleratorPedal?.wiringHarnessConnectorGotDisconnected,
    q12o3: acceleratorPedal?.foundFaulty,
    noSupplyVoltageInHarnessConnector:
      acceleratorPedal?.noSupplyVoltageInHarnessConnector,
  };
  return responseDetails;
};

export const ENGINE_SIDE_QUESTIONS = [
  {
    label: "Manually tried rotating the crankshaft and observed",
    apiKey: "onManualRotationOfCrankshaft",
    type: "RADIO",
    options: [
      {
        label: "FREE FULL ROTATION",
        apiOptionKey: "FREE_FULL_ROTATION",
        value: "FREE_FULL_ROTATION",
      },
      {
        label: "HARD TO ROTATE",
        apiOptionKey: "HARD_TO_ROTATE",
        value: "HARD_TO_ROTATE",
      },
      {
        label: "ONLY HALF ROTATION",
        apiOptionKey: "ONLY_HALF_ROTATION",
        value: "ONLY_HALF_ROTATION",
      },
      {
        label: "NOT ROTATING",
        apiOptionKey: "NOT_ROTATING",
        value: "NOT_ROTATING",
      },
    ],
  },
  {
    label: "Valve Tip Clearance",
    apiKey: "valveTipClearance",
    type: "RADIO",
    options: [
      {
        label: "FOUND EXCESS CLEARANCE",
        apiOptionKey: "FOUND_EXCESS_CLEARANCE",
        value: "FOUND_EXCESS_CLEARANCE",
      },
      {
        label: "FOUND LESS CLEARANCE",
        apiOptionKey: "FOUND_LESS_CLEARANCE",
        value: "FOUND_LESS_CLEARANCE",
      },
      { label: "FOUND OK", apiOptionKey: "FOUND_OK", value: "FOUND_OK" },
    ],
  },
  {
    label: "Valve tip clearance observed Values",
    options: [
      {
        label: "1st Cylinder In",
        type: "INPUT",
        apiOptionKey: "o1",
      },
      {
        label: "1st Cylinder EXh",
        type: "INPUT",
        apiOptionKey: "o2",
      },
      {
        label: "2st Cylinder In",
        type: "INPUT",
        apiOptionKey: "o3",
      },
      {
        label: "2st Cylinder EXh",
        type: "INPUT",
        apiOptionKey: "o4",
      },
      {
        label: "3st Cylinder In",
        type: "INPUT",
        apiOptionKey: "o5",
      },
      {
        label: "3st Cylinder EXh",
        type: "INPUT",
        apiOptionKey: "o6",
      },
      {
        label: "4st Cylinder In",
        type: "INPUT",
        apiOptionKey: "o7",
      },
      {
        label: "4st Cylinder EXh",
        type: "INPUT",
        apiOptionKey: "o8",
      },
    ],
  },
  {
    label: "Tappet Cover",
    options: [
      { label: "Found OK", apiOptionKey: "foundOk" },
      {
        label: "Found joint dislocation",
        apiOptionKey: "foundJointDislocation",
      },
      { label: "Found Joint damaged", apiOptionKey: "foundJointDamaged" },
      { label: "Found baffle plate ok", apiOptionKey: "foundBafflePlateOk" },
      { label: "No Baffle plate", apiOptionKey: "noBafflePlate" },
      {
        label: "Baffle plate found blocked",
        apiOptionKey: "bafflePlateFoundBlocked",
      },
    ],
  },
  {
    label: "Exhaust Smoke Condition",
    apiKey: "exhaustSmokeCondition",
    type: "RADIO",
    options: [
      {
        label: "NOT_VISIBLE",
        apiOptionKey: "NOT_VISIBLE",
        value: "NOT_VISIBLE",
      },
      {
        label: "BLACK",
        apiOptionKey: "BLACK",
        value: "BLACK",
      },
      {
        label: "WHITE",
        apiOptionKey: "WHITE",
        value: "WHITE",
      },
    ],
  },
  {
    label: "Any abnormal sound observed",
    apiKey: "anyAbnormalSound",
    type: "RADIO",
    options: [
      { label: "YES", apiOptionKey: "YES", value: "YES" },
      { label: "NO", apiOptionKey: "NO", value: "NO" },
    ],
  },
  {
    label: "Abnormal sound observed from",
    apiKey: "abnormalSoundObservedFrom",
    options: [
      { label: "Front side", apiOptionKey: "frontSide" },
      { label: "Rear Side", apiOptionKey: "rearSide" },
      { label: "Top Side", apiOptionKey: "topSide" },
      { label: "Bottom Side", apiOptionKey: "bottomSide" },
    ],
  },
];

export const mappingEngineSideDetailsToUI = (details) => {
  let responseDetails = {
    onManualRotationOfCrankshaft: details.onManualRotationOfCrankshaft,
    valveTipClearance: details.valveTipClearance,

    foundOk: details?.tappetCover?.foundOk,
    foundJointDislocation: details?.tappetCover?.foundJointDislocation,
    foundJointDamaged: details?.tappetCover?.foundJointDamaged,
    foundBafflePlateOk: details?.tappetCover?.foundBafflePlateOk,
    noBafflePlate: details?.tappetCover?.noBafflePlate,
    bafflePlateFoundBlocked: details?.tappetCover?.bafflePlateFoundBlocked,

    exhaustSmokeCondition: details.exhaustSmokeCondition,
    anyAbnormalSound: details.anyAbnormalSound,

    frontSide: details?.abnormalSoundObservedFrom?.frontSide,
    rearSide: details?.abnormalSoundObservedFrom?.rearSide,
    topSide: details?.abnormalSoundObservedFrom?.topSide,
    bottomSide: details?.abnormalSoundObservedFrom?.bottomSide,
    o1: details?.valveTipClearanceValues?.firstCylinder?.in,
    o2: details?.valveTipClearanceValues?.firstCylinder?.exh,
    o3: details?.valveTipClearanceValues?.secondCylinder?.in,
    o4: details?.valveTipClearanceValues?.secondCylinder?.exh,
    o5: details?.valveTipClearanceValues?.thirdCylinder?.in,
    o6: details?.valveTipClearanceValues?.thirdCylinder?.exh,
    o7: details?.valveTipClearanceValues?.fourthCylinder?.in,
    o8: details?.valveTipClearanceValues?.fourthCylinder?.exh,
  };

  return responseDetails;
};

export const ENGINE_CONDITION_QUESTIONS = [
  {
    label: "After removing the Tappet cover",
    options: [
      { label: "Observed Rocker shaft Bend", apiOptionKey: "q1o1" },
      { label: "Observed rocker shaft damaged", apiOptionKey: "q1o2" },
      { label: "Observed Over heating symptoms", apiOptionKey: "q1o3" },
      { label: "Observed Oil burnt smell", apiOptionKey: "q1o4" },
      {
        label: "Observed no oil coming from Rocker shaft",
        apiOptionKey: "q1o5",
      },
      { label: "Observed No Oil in Cylinder head", apiOptionKey: "q1o6" },
    ],
  },
  {
    label: "Push rod Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q2o1" },
      { label: "Found bend", apiOptionKey: "q2o2" },
      { label: "Found broken", apiOptionKey: "q2o3" },
      {
        label: "Remarks : Mention the exact push rod number",
        type: "INPUT",
        apiOptionKey: "q2o4",
      },
    ],
  },
  {
    label: "Tappet / Cam follower condition",
    options: [
      { label: "Found ok", apiOptionKey: "q3o1" },
      { label: "Found bend", apiOptionKey: "q3o2" },
      { label: "Found broken", apiOptionKey: "q3o3" },
      {
        label: "Remarks : Mention the exact push rod number",
        type: "INPUT",
        apiOptionKey: "q3o4",
      },
    ],
  },
  {
    label: "Camshaft Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q4o1" },
      { label: "Observed Camshaft broken in to pieces", apiOptionKey: "q4o2" },
      {
        label: "Observed Camshaft gear mounting bolt broken",
        apiOptionKey: "q4o3",
      },
    ],
  },
  {
    label: "Piston Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q5o1" },
      { label: "Coolant traces observed", apiOptionKey: "q5o2" },
      { label: "Found Piston seized", apiOptionKey: "q5o3" },
      { label: "Found pitting marks on piston", apiOptionKey: "q5o4" },
      { label: "Found Melted", apiOptionKey: "q5o5" },
      { label: "Found unburnt fuel on piston", apiOptionKey: "q5o6" },
      { label: "Found Valve hitting Mark", apiOptionKey: "q5o7" },
      { label: "Rings got seized with Piston", apiOptionKey: "q5o8" },
      { label: "Found overheating traces", apiOptionKey: "q5o9" },
      { label: "Found heavy carbon deposit", apiOptionKey: "q5o10" },
      {
        label: "Found Foreign Particle on top of the piston",
        apiOptionKey: "q5o11",
      },
      { label: "Found Piston damage / Broken", apiOptionKey: "q5o12" },
      {
        label: "Remarks :Mention the exact Piston number",
        apiOptionKey: "q5o13",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Liner Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q6o1" },
      { label: "Found crack", apiOptionKey: "q6o2" },
      { label: "Found glazed", apiOptionKey: "q6o3" },
      { label: "Found Patch marks", apiOptionKey: "q6o4" },
      { label: "Found Scoring Marks", apiOptionKey: "q6o5" },
      { label: "Found damaged", apiOptionKey: "q6o6" },
      {
        label: "Remarks : Mention the exact Liner number",
        type: "INPUT",
        apiOptionKey: "q6o7",
      },
    ],
  },
  // Protrusion and Ring gap sections unchanged (q7–q18)
  {
    label: "Connecting Rod Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q19o1" },
      { label: "Found broken", apiOptionKey: "q19o2" },
      { label: "Found bend", apiOptionKey: "q19o3" },
      {
        label: "Found conrod mounting bolt torque relaxation",
        apiOptionKey: "q19o4",
      },
      { label: "Found conrod bearing seizer mark", apiOptionKey: "q19o5" },
      { label: "Found conrod bearing washed out", apiOptionKey: "q19o6" },
      {
        label: "Remarks : Mention the exact Conrod number",
        type: "INPUT",
        apiOptionKey: "q19o7",
      },
    ],
  },
  {
    label: "Main bearing Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q20o1" },
      { label: "Found conrod bearing seizer mark", apiOptionKey: "q20o2" },
      { label: "Found conrod bearing washed out", apiOptionKey: "q20o3" },
      {
        label: "Remarks : Mention the exact Conrod number",
        apiOptionKey: "q20o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Main bearing Cap Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q21o1" },
      { label: "Found broken", apiOptionKey: "q21o2" },
      { label: "Found mounting bolt torque relaxation", apiOptionKey: "q21o3" },
      {
        label: "Remarks : Mention the exact Conrod number",
        type: "INPUT",
        apiOptionKey: "q21o4",
      },
    ],
  },
  {
    label: "Crankshaft Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q22o1" },
      { label: "Found crank Pin broken", apiOptionKey: "q22o2" },
      { label: "Found bend", apiOptionKey: "q22o3" },
      { label: "Found excess end play", apiOptionKey: "q22o4" },
      { label: "Found crack at", apiOptionKey: "q22o5", type: "INPUT" },
      {
        label: "Found seizer mark in crank pin",
        apiOptionKey: "q22o6",
      },
      {
        label: "Found thrust washer washed out",
        apiOptionKey: "q22o7",
      },
    ],
  },
  {
    label: "Cylinder head Gasket condition",
    options: [
      { label: "Found ok", apiOptionKey: "q23o1" },
      {
        label: "Found compression gas leakage between",
        apiOptionKey: "q23o2",
        type: "INPUT",
      },
      {
        label: "Found Gasket blow- off between",
        apiOptionKey: "q23o3",
        type: "INPUT",
      },
      {
        label: "Mention other relevant details",
        apiOptionKey: "q23o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Cylinder head bolt condition",
    options: [
      { label: "Found ok", apiOptionKey: "q24o1" },
      {
        label: "Found torque relaxation",
        apiOptionKey: "q24o2",
        type: "INPUT",
      },
      {
        label: "Mention other relevant details",
        apiOptionKey: "q24o3",
        type: "INPUT",
      },
    ],
  },
  {
    label:
      "Whether water rising uniformly while filled in Cylinder block water jackets",
    apiKey: "whetherWaterRisingUniformlyWhileFilledInCylinderBlockWaterJackets",
    type: "RADIO",
    options: [
      { label: "YES", apiOptionKey: "q25o1", value: "YES" },
      { label: "NO", apiOptionKey: "q25o2", value: "NO" },
    ],
  },
];

export const mappingEngineConditionDetailsToUI = (details) => {
  const {
    afterRemovingTappetCover = {},
    pushRodCondition = {},
    tappetOrCamFollowerCondition = {},
    camshaftCondition = {},
    pistonCondition = {},
    linearCondition = {},
    linearProtrusionValuesInMM = {},
    pistonProtrusionValuesInMM = {},
    topRingGapClearanceInLinearPistonRemovedRingsInMM = {},
    topRingGapClearanceInLinearNewRingsInMM = {},
    connectingRodCondition = {},
    mainBearingCondition = {},
    crankShaftCondition = {},
    cylinderHeadGasketCondition = {},
    cylinderHeadBoltCondition = {},
    mainBearingCapCondition = {},
    whetherWaterRisingUniformlyWhileFilledInCylinderBlockWaterJackets,
  } = details;

  let responseDetails = {
    q1o1: afterRemovingTappetCover.observedRockerShaftBend,
    q1o2: afterRemovingTappetCover.observedRockerShaftDamaged,
    q1o3: afterRemovingTappetCover.observedOverheatingSymptoms,
    q1o4: afterRemovingTappetCover.observedOilBurntSmell,
    q1o5: afterRemovingTappetCover.observedNoOilComingFromRockerShaft,
    q1o6: afterRemovingTappetCover.observedNoOilInCylinderHead,

    q2o1: pushRodCondition?.foundOk,
    q2o2: pushRodCondition?.foundBend,
    q2o3: pushRodCondition?.foundBroken,
    q2o4: pushRodCondition?.comment,

    q3o1: tappetOrCamFollowerCondition?.foundOk,
    q3o2: tappetOrCamFollowerCondition?.foundBend,
    q3o3: tappetOrCamFollowerCondition?.foundBroken,
    q3o4: tappetOrCamFollowerCondition?.comment,

    q4o1: camshaftCondition?.foundOk,
    q4o2: camshaftCondition?.observedCamshaftBrokenIntoPieces,
    q4o3: camshaftCondition?.observedCamshaftGearMountingBoltBroken,

    q5o1: pistonCondition?.foundOk,
    q5o2: pistonCondition?.coolantTracesObserved,
    q5o3: pistonCondition?.foundPistonSeized,
    q5o4: pistonCondition?.foundPittingMarksOnPiston,
    q5o5: pistonCondition?.foundMelted,
    q5o6: pistonCondition?.foundUnburntFuelOnPiston,
    q5o7: pistonCondition?.foundValveHittingMark,
    q5o8: pistonCondition?.ringsGotSeizedWithPiston,
    q5o9: pistonCondition?.foundOverheatingTraces,
    q5o10: pistonCondition?.foundHeavyCarbonDeposit,
    q5o11: pistonCondition?.foundForeignparticleOnTopOfPiston,
    q5o12: pistonCondition?.foundPistonDamageOrBroken,
    q5o13: pistonCondition?.comment,

    q6o1: linearCondition.foundOk,
    q6o2: linearCondition.foundCrack,
    q6o3: linearCondition.foundGlaze,
    q6o4: linearCondition.foundPatchMarks,
    q6o5: linearCondition.foundScoringMarks,
    q6o6: linearCondition.foundDamaged,
    q6o7: linearCondition.comment,

    q7o1: linearProtrusionValuesInMM?.cylinder1?.["1"],
    q7o2: linearProtrusionValuesInMM?.cylinder1?.["2"],
    q7o3: linearProtrusionValuesInMM?.cylinder1?.["3"],
    q7o4: linearProtrusionValuesInMM?.cylinder1?.["4"],

    q8o1: linearProtrusionValuesInMM?.cylinder2?.["1"],
    q8o2: linearProtrusionValuesInMM?.cylinder2?.["2"],
    q8o3: linearProtrusionValuesInMM?.cylinder2?.["3"],
    q8o4: linearProtrusionValuesInMM?.cylinder2?.["4"],

    q9o1: linearProtrusionValuesInMM?.cylinder3?.["1"],
    q9o2: linearProtrusionValuesInMM?.cylinder3?.["2"],
    q9o3: linearProtrusionValuesInMM?.cylinder3?.["3"],
    q9o4: linearProtrusionValuesInMM?.cylinder3?.["4"],

    q10o1: linearProtrusionValuesInMM?.cylinder4?.["1"],
    q10o2: linearProtrusionValuesInMM?.cylinder4?.["2"],
    q10o3: linearProtrusionValuesInMM?.cylinder4?.["3"],
    q10o4: linearProtrusionValuesInMM?.cylinder4?.["4"],

    q11o1: pistonProtrusionValuesInMM?.cylinder1?.["1"],
    q11o2: pistonProtrusionValuesInMM?.cylinder1?.["2"],
    q11o3: pistonProtrusionValuesInMM?.cylinder1?.["3"],
    q11o4: pistonProtrusionValuesInMM?.cylinder1?.["4"],

    q12o1: pistonProtrusionValuesInMM?.cylinder2?.["1"],
    q12o2: pistonProtrusionValuesInMM?.cylinder2?.["2"],
    q12o3: pistonProtrusionValuesInMM?.cylinder2?.["3"],
    q12o4: pistonProtrusionValuesInMM?.cylinder2?.["4"],

    q13o1: pistonProtrusionValuesInMM?.cylinder3?.["1"],
    q13o2: pistonProtrusionValuesInMM?.cylinder3?.["2"],
    q13o3: pistonProtrusionValuesInMM?.cylinder3?.["3"],
    q13o4: pistonProtrusionValuesInMM?.cylinder3?.["4"],

    q14o1: pistonProtrusionValuesInMM?.cylinder4?.["1"],
    q14o2: pistonProtrusionValuesInMM?.cylinder4?.["2"],
    q14o3: pistonProtrusionValuesInMM?.cylinder4?.["3"],
    q14o4: pistonProtrusionValuesInMM?.cylinder4?.["4"],

    q15o1:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder1?.["top"],
    q15o2:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder1?.["middle"],
    q15o3:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder1?.["bottom"],

    q16o1:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder2?.["top"],
    q16o2:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder2?.["middle"],
    q16o3:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder2?.["bottom"],

    q17o1:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder3?.["top"],
    q17o2:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder3?.["middle"],
    q17o3:
      topRingGapClearanceInLinearPistonRemovedRingsInMM?.cylinder3?.["bottom"],

    q18o1: topRingGapClearanceInLinearNewRingsInMM?.cylinder1?.["top"],
    q18o2: topRingGapClearanceInLinearNewRingsInMM?.cylinder1?.["middle"],
    q18o3: topRingGapClearanceInLinearNewRingsInMM?.cylinder1?.["bottom"],

    q19o1: connectingRodCondition.foundOk,
    q19o2: connectingRodCondition.foundBroken,
    q19o3: connectingRodCondition.foundBend,
    q19o4: connectingRodCondition.foundConrodMountingBoltTorqueRelaxation,
    q19o5: connectingRodCondition.foundConrodBearingSeizerMark,
    q19o6: connectingRodCondition.foundConrodBearingWashedOut,
    q19o7: connectingRodCondition.comment,

    q20o1: mainBearingCondition.foundOk,
    q20o2: mainBearingCondition.foundConrodBearingSeizerMark,
    q20o3: mainBearingCondition.foundConrodBearingWashedOut,
    q20o4: mainBearingCondition.comment,

    q21o1: mainBearingCapCondition.foundOk,
    q21o2: mainBearingCapCondition.foundBroken,
    q21o3: mainBearingCapCondition.foundMountingBoltTorqueRelaxation,
    q21o4: mainBearingCapCondition.comment,

    q22o1: crankShaftCondition.foundOk,
    q22o2: crankShaftCondition.foundCrankPinBroken,
    q22o3: crankShaftCondition.foundBend,
    q22o4: crankShaftCondition.foundExcessEndPlay,
    q22o5: crankShaftCondition.foundCrackAt,
    q22o6: crankShaftCondition.foundSeizerMarkInCrankPin,
    q22o7: crankShaftCondition.foundThrustWasherWashedOut,

    q23o1: cylinderHeadGasketCondition.foundOk,
    q23o2: cylinderHeadGasketCondition.foundCompressionGasLeakageBetween,
    q23o3: cylinderHeadGasketCondition.foundGasketBlowOffBetween,
    q23o4: cylinderHeadGasketCondition.comment,

    q24o1: cylinderHeadBoltCondition.foundOk,
    q24o2: cylinderHeadBoltCondition.foundTorqueRelaxation,
    q24o3: cylinderHeadBoltCondition.comment,

    q25o1:
      whetherWaterRisingUniformlyWhileFilledInCylinderBlockWaterJackets ===
      "YES",
    q25o2:
      whetherWaterRisingUniformlyWhileFilledInCylinderBlockWaterJackets ===
      "NO",
  };

  return responseDetails;
};

export const VEHICLE_END_QUESTIONS = [
  {
    label: "Equipment Tyre Pressure in Kg/cm2",
    options: [
      { label: "Front", apiOptionKey: "q1o1", type: "INPUT" },
      { label: "Rear", apiOptionKey: "q1o2", type: "INPUT" },
      { label: "Water Blasting done in rear tyre", apiOptionKey: "q1o3" },
    ],
  },

  {
    label: "Tyre Size Front (Front & Rear )",
    options: [
      { label: "Front", apiOptionKey: "q2o1", type: "INPUT" },
      { label: "Rear", apiOptionKey: "q2o2", type: "INPUT" },
    ],
  },

  {
    label: "Clutch Condition",
    apiKey: "q3o1",
    type: "RADIO",
    options: [
      { label: "Found Normal", apiOptionKey: "q3o1", value: "Found Normal" },
      {
        label: "Found Slipping",
        apiOptionKey: "q3o2",
        value: "Found Slipping",
      },
    ],
  },
  {
    label: "Break condition",
    options: [
      { label: "Found Normal", apiOptionKey: "q4o1" },
      { label: "Found Binding", apiOptionKey: "q4o2" },
      { label: "Not Working Slipping", apiOptionKey: "q4o2" },
    ],
  },
  {
    label: "Gear Selection",
    apiKey: "q5o1",
    type: "INPUT",
    options: [],
  },
  {
    label: "Load Condition",
    options: [
      { label: "Found Normal", apiOptionKey: "q6o1" },
      { label: "Light Load used", apiOptionKey: "q6o2" },
      { label: "Heavy Load Used", apiOptionKey: "q6o2" },
    ],
  },
  {
    label: "Type of Implement used",
    apiKey: "q7o1",
    type: "INPUT",
    options: [],
  },
  {
    label: "Soil condition",
    options: [
      { label: "Wet", apiOptionKey: "q8o1" },
      { label: "Dry	", apiOptionKey: "q8o2" },
      { label: "Hard", apiOptionKey: "q8o3" },
      {
        label: "Loose",
        apiOptionKey: "q8o4",
      },
    ],
  },
  {
    label: "Pulling Power",
    options: [
      { label: "Normal", apiOptionKey: "q9o1" },
      { label: "RPM Drop observed", apiOptionKey: "q9o2" },
      {
        label: "RPM Drop Value",
        apiOptionKey: "q9o3",
        type: "INPUT",
      },
    ],
  },
  {
    label:
      "Average Ambient Temperature at site in OC(Note : Mention the temperature)",
    apiKey: "q10o1",
    type: "INPUT",
    options: [],
  },
  {
    label:
      "Present Ambient Temperature at site in OC( Mention the temperature)",
    apiKey: "q11o1",
    type: "INPUT",
    options: [],
  },
  {
    label: "Crop(Note : Mention the crop)",
    apiKey: "q12o1",
    type: "INPUT",
    options: [],
  },
  {
    label: "Depth setting on Implements (Note : Mention the relevent details)",
    apiKey: "q13o1",
    type: "INPUT",
    options: [],
  },
  {
    label:
      "Any modification in tail pipe, other than OE fitment (Note : Mention the relevent details)",
    apiKey: "q14o1",
    type: "INPUT",
    options: [],
  },
];

export const mappingVehicleEndDetailsToUI = (details) => {
  const {
    equipmentTyrePressureInKgPerCmSquare,
    tyreSize,
    clutchCondition,
    breakCondition,
    gearSelection,
    loadCondition,
    typeOfImplementUsed,
    soilCondition,
    pullingPower,
    averageAmbientTempratureAtSiteInOC,
    presentAmbientTempratureAtSiteInOC,
    crop,
    depthSettingOnImplements,
    anyModificationInTailPipeOtherThanOEFitment,
  } = details;

  let responseDetails = {
    q1o1: equipmentTyrePressureInKgPerCmSquare?.front,
    q1o2: equipmentTyrePressureInKgPerCmSquare?.rear,
    q1o3: equipmentTyrePressureInKgPerCmSquare?.waterBlastingDoneInRearTyre,

    q2o1: tyreSize?.front,
    q2o2: tyreSize?.rear,

    q3o1: clutchCondition?.foundNormal,
    q3o2: clutchCondition?.foundSlipping,

    q4o1: breakCondition?.foundNormal,
    q4o2: breakCondition?.foundBinding,
    q4o3: breakCondition?.notWorking,

    q501: gearSelection,

    q6o1: loadCondition?.foundNormal,
    q6o2: loadCondition?.lightLoadUsed,
    q6o3: loadCondition?.heavyLoadUsed,

    q7o1: typeOfImplementUsed,

    q8o1: soilCondition?.wet,
    q8o2: soilCondition?.dry,
    q8o3: soilCondition?.hard,
    q8o4: soilCondition?.loose,

    q9o1: pullingPower?.normal,
    q9o2: pullingPower?.rpmDropObserved,
    q9o3: pullingPower?.rpmDropValue,

    q10o1: averageAmbientTempratureAtSiteInOC,
    q11o1: presentAmbientTempratureAtSiteInOC,
    q12o1: crop,
    q13o1: depthSettingOnImplements,
    q14o1: anyModificationInTailPipeOtherThanOEFitment,
  };

  return responseDetails;
};

export const LOC_TRAIL_QUESTION = [
  {
    label: "A. Weight of clean empty Container",
    apiKey: "weightOfCleanEmptyContainerKg",
    type: "INPUT",
    options: [],
  },
  {
    label: "B. Weight of Container with lube Oil",
    apiKey: "weightOfContainerWithLubeOilKg",
    type: "INPUT",
    options: [],
  },
  {
    label: "C. Weight of container after Oil is poured in to engine",
    apiKey: "weightOfContainerAfterOilIsPouredInToEngineKg",
    type: "INPUT",
    options: [],
  },
  {
    label: "D. Actual Weight of oil poured to sump (D = C - D - A)",
    apiKey: "actualWeightOfOilPouredToSumpKg",
    type: "INPUT",
    options: [],
  },
  {
    label: "E. Meassured Volume of Fuel Filled in Fuel Tank",
    apiKey: "measuredVolumeOfFuelFilledInFuelTankInLtr",
    type: "INPUT",
    options: [],
  },
  {
    label: "F. Weight of drained oil with container (H = F - B)",
    apiKey: "weightOfDrainedOilWithContainerKg",
    type: "INPUT",
    options: [],
  },
  {
    label: "H. Actual Weight of oil drained",
    apiKey: "actualWeightOfOilDrained",
    type: "INPUT",
    options: [],
  },
  {
    label: "I. Actual Fuel drained",
    apiKey: "actualFuelDrainedInLtr",
    type: "INPUT",
    options: [],
  },
  {
    label: "J. LOC for 4 hrs  (H * 0.893)",
    apiKey: "lubOilConsumptionInLtr",
    type: "INPUT",
    options: [],
  },
  {
    label: "K. Fuel Consumption for 4 hrs. K =(E-I)",
    apiKey: "fuelConsumptionInLtr",
    type: "INPUT",
    options: [],
  },
  {
    label: "LOC IN % OF FC : (J / K) * 100",
    apiKey: "lubeOilConsumptionPercentOfFC",
    type: "INPUT",
    options: [],
  },
];

export const mappingLOCTrailDetailsToUI = (details) => {
  let responseDetails = {
    weightOfCleanEmptyContainerKg: details.weightOfCleanEmptyContainerKg,
    weightOfContainerWithLubeOilKg: details.weightOfContainerWithLubeOilKg,
    weightOfContainerAfterOilIsPouredInToEngineKg:
      details.weightOfContainerAfterOilIsPouredInToEngineKg,
    actualWeightOfOilPouredToSumpKg: details.actualWeightOfOilPouredToSumpKg,
    measuredVolumeOfFuelFilledInFuelTankInLtr:
      details.measuredVolumeOfFuelFilledInFuelTankInLtr,
    weightOfDrainedOilWithContainerKg:
      details.weightOfDrainedOilWithContainerKg,
    actualWeightOfOilDrained: details.actualWeightOfOilDrained,
    actualFuelDrainedInLtr: details.actualFuelDrainedInLtr,
    lubOilConsumptionInLtr: details.lubOilConsumptionInLtr,
    fuelConsumptionInLtr: details.fuelConsumptionInLtr,
    lubeOilConsumptionPercentOfFC: details.lubeOilConsumptionPercentOfFC,
  };

  return responseDetails;
};
export const OTHER_OBSERVATION_QUESTIONS = [
  {
    label: "Fuel pump Gear",
    options: [
      { label: "Found ok", apiOptionKey: "q1o1" },
      {
        label: "Found Gear teeth damaged",
        apiOptionKey: "q1o2",
      },
      {
        label: "Observed mounting bolt got relaxed",
        apiOptionKey: "q1o3",
      },
      {
        label: "Observed mounting bold missing",
        apiOptionKey: "q1o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q1o5",
      },
    ],
  },
  {
    label: "Lower Idler Gear",
    options: [
      { label: "Found ok", apiOptionKey: "q2o1" },
      {
        label: "Found Gear teeth damaged",
        apiOptionKey: "q2o2",
      },
      {
        label: "Observed mounting bolt got relaxed",
        apiOptionKey: "q2o3",
      },
      {
        label: "Observed mounting bold missing",
        apiOptionKey: "q2o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q2o5",
      },
    ],
  },
  {
    label: "Upper Idler Gear",
    options: [
      { label: "Found ok", apiOptionKey: "q3o1" },
      {
        label: "Found Gear teeth damaged",
        apiOptionKey: "q3o2",
      },
      {
        label: "Observed mounting bolt got relaxed",
        apiOptionKey: "q3o3",
      },
      {
        label: "Observed mounting bold missing",
        apiOptionKey: "q3o4",
      },
      {
        label: "Observed bearing bush worn out",
        apiOptionKey: "q3o5",
      },
      {
        label: "Observed oil feed pipe damaged",
        apiOptionKey: "q3o6",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q3o7",
      },
    ],
  },
  {
    label: "Bigger Idler Gear",
    options: [
      { label: "Found ok", apiOptionKey: "q4o1" },
      {
        label: "Found Gear teeth damaged",
        apiOptionKey: "q4o2",
      },
      {
        label: "Observed mounting bolt got relaxed",
        apiOptionKey: "q4o3",
      },
      {
        label: "Observed mounting bold missing",
        apiOptionKey: "q4o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q4o5",
      },
    ],
  },
  {
    label: "Timing case cover",
    options: [
      { label: "Found ok", apiOptionKey: "q6o1" },
      {
        label: "Found crack near",
        type: "INPUT",
        apiOptionKey: "q6o2",
      },
      {
        label: "Found oil leakage at",
        type: "INPUT",
        apiOptionKey: "q6o3",
      },
      {
        label: "observed Front Oil Seal leakage",
        type: "INPUT",
        apiOptionKey: "q6o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q6o5",
      },
      {
        label: "Found broken at	",
        apiOptionKey: "q6o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Cylinder head",
    options: [
      { label: "Found ok", apiOptionKey: "q7o1" },
      {
        label: "Found crack near",
        type: "INPUT",
        apiOptionKey: "q7o2",
      },
      {
        label: "Found oil leakage at",
        type: "INPUT",
        apiOptionKey: "q7o3",
      },
      {
        label: "Found Blow hole",
        type: "INPUT",
        apiOptionKey: "q7o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q7o5",
      },
      {
        label: "Found broken at",
        apiOptionKey: "q7o4",
        type: "INPUT",
      },
      {
        label: "Found Coolant leakage at",
        apiOptionKey: "q7o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Cylinder Block",
    options: [
      { label: "Found ok", apiOptionKey: "q8o1" },
      {
        label: "Found crack near",
        type: "INPUT",
        apiOptionKey: "q8o2",
      },
      {
        label: "Found oil leakage at",
        type: "INPUT",
        apiOptionKey: "q8o3",
      },
      {
        label: "Found Blow hole",
        type: "INPUT",
        apiOptionKey: "q8o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q8o5",
      },
      {
        label: "Found broken at",
        apiOptionKey: "q8o4",
        type: "INPUT",
      },
      {
        label: "Found Coolant leakage at",
        apiOptionKey: "q8o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Inlet Valve",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      {
        label: "Found crack at",
        type: "INPUT",
        apiOptionKey: "q9o2",
      },
      {
        label: "Found damaged at",
        type: "INPUT",
        apiOptionKey: "q9o3",
      },
      {
        label: "Found bend",
        type: "INPUT",
        apiOptionKey: "q9o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q9o5",
      },
      {
        label: "Found heavy carbon deposit",
        apiOptionKey: "q9o4",
        type: "INPUT",
      },
      {
        label: "Found valve seat leakage at",
        apiOptionKey: "q9o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Exhaust Valve",
    options: [
      { label: "Found ok", apiOptionKey: "q10o1" },
      {
        label: "Found crack at",
        type: "INPUT",
        apiOptionKey: "q10o2",
      },
      {
        label: "Found damaged at",
        type: "INPUT",
        apiOptionKey: "q10o3",
      },
      {
        label: "Found bend",
        type: "INPUT",
        apiOptionKey: "q10o4",
      },
      {
        label: "Note : Mention any other observation",
        type: "INPUT",
        apiOptionKey: "q10o5",
      },
      {
        label: "Found heavy carbon deposit",
        apiOptionKey: "q10o4",
        type: "INPUT",
      },
      {
        label: "Found valve seat leakage at",
        apiOptionKey: "q10o4",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Valve Spring Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q11o1" },
      {
        label: "Found Compressed",
        type: "INPUT",
        apiOptionKey: "q11o2",
      },
      {
        label: "Remarks : Mention any relevent details",
        type: "INPUT",
        apiOptionKey: "q11o3",
      },
    ],
  },
];
export const mappingOtherDetailsToUI = (details) => {
  const {
    fuelPumpGear,
    lowerIdlerGear,
    upperIdlerGear,
    biggerIdlerGear,
    timingCaseCover,
    timingCase,
    cylinderHead,
    cylinderBlock,
    inletValve,
    exhaustValve,
    valveSpringCondition,
  } = details;
  let responseDetails = {
    q1o1: fuelPumpGear?.foundOk,
    q1o2: fuelPumpGear?.foundGearTeethDamaged,
    q1o3: fuelPumpGear?.observedMountingBoltGotRelaxed,
    q1o4: fuelPumpGear?.observedMountingBoltMissing,
    q1o5: fuelPumpGear?.otherObservation,

    q2o1: lowerIdlerGear?.foundOk,
    q2o2: lowerIdlerGear?.foundGearTeethDamaged,
    q2o3: lowerIdlerGear?.observedMountingBoltGotRelaxed,
    q2o4: lowerIdlerGear?.observedMountingBoltMissing,
    q2o5: lowerIdlerGear?.otherObservation,

    q3o1: upperIdlerGear?.foundOk,
    q3o2: upperIdlerGear?.foundGearTeethDamaged,
    q3o3: upperIdlerGear?.observedMountingBoltGotRelaxed,
    q3o4: upperIdlerGear?.observedMountingBoltMissing,
    q3o5: upperIdlerGear?.observedBearingBushWornOut,
    q3o6: upperIdlerGear?.observedOilFeedPipeDamaged,
    q3o7: upperIdlerGear?.otherObservation,

    q4o1: biggerIdlerGear?.foundOk,
    q4o2: biggerIdlerGear?.foundGearTeethDamaged,
    q4o3: biggerIdlerGear?.observedMountingBoltGotRelaxed,
    q4o4: biggerIdlerGear?.observedMountingBoltMissing,
    q4o5: biggerIdlerGear?.otherObservation,

    q5o1: timingCaseCover?.foundOk,
    q5o2: timingCaseCover?.foundCrackNear,
    q5o3: timingCaseCover?.foundOilLeakageAt,
    q5o4: timingCaseCover?.observedFrontOilSealLeakage,
    q5o5: timingCaseCover?.foundBrokenAt,
    q5o6: timingCaseCover?.otherObservation,

    q6o1: timingCase?.foundOk,
    q6o2: timingCase?.foundCrackNear,
    q6o3: timingCase?.foundOilLeakageAt,
    q6o4: timingCase?.observedFrontOilSealLeakage,
    q6o5: timingCase?.foundBrokenAt,
    q6o6: timingCase?.otherObservation,

    q7o1: cylinderHead?.foundOk,
    q7o2: cylinderHead?.foundCrackNear,
    q7o3: cylinderHead?.foundOilLeakageAt,
    q7o4: cylinderHead?.foundBlowHole,
    q7o5: cylinderHead?.foundBrokenAt,
    q7o6: cylinderHead?.foundCoolantLeakageAt,
    q7o7: cylinderHead?.otherObservation,

    q8o1: cylinderBlock?.foundOk,
    q8o2: cylinderBlock?.foundCrackNear,
    q8o3: cylinderBlock?.foundOilLeakageAt,
    q8o4: cylinderBlock?.foundBlowHole,
    q8o5: cylinderBlock?.foundBrokenAt,
    q8o6: cylinderBlock?.foundCoolantLeakageAt,
    q8o7: cylinderBlock?.otherObservation,

    q9o1: inletValve?.foundOk,
    q9o2: inletValve?.foundCrackAt,
    q9o3: inletValve?.foundDamagedAt,
    q9o4: inletValve?.foundBend,
    q9o5: inletValve?.foundHeavyCarbonDeposit,
    q9o6: inletValve?.foundValveSeatLeakageAt,
    q9o7: inletValve?.otherObservation,

    q10o1: exhaustValve?.foundOk,
    q10o2: exhaustValve?.foundCrackAt,
    q10o3: exhaustValve?.foundDamagedAt,
    q10o4: exhaustValve?.foundBend,
    q10o5: exhaustValve?.foundHeavyCarbonDeposit,
    q10o6: exhaustValve?.foundValveSeatLeakageAt,
    q10o7: exhaustValve?.otherObservation,

    q11o1: valveSpringCondition?.foundOk,
    q11o2: valveSpringCondition?.foundCompressed,
    q11o3: valveSpringCondition?.otherDetails,
  };
  return responseDetails;
};
